import React, {useEffect, useState} from "react";
import {EnigooSelectMulti} from "../../EnigooSelectMulti";
import {EnigooSelect} from "../../EnigooSelect";
import PropTypes from "prop-types";
import {apiGetDevice} from "../../../Admin/pages/Device/Actions";

export const DeviceSelectField = ({
                                      label,
                                      name,
                                      isMulti = true,
                                      outsideClassName = "w-full",
                                      onChange = null
                                  }) => {
    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    //data z databaze
    useEffect(() => {
        get()
    }, [])

    const get = () => {
        setLoading(true);
        apiGetDevice((data) => {
            setData(data);
            setLoading(false);
        }, (error) => {
            setLoading(false);
        })
    }
    return (isMulti ? <EnigooSelectMulti onValueChange={onChange} outsideClassName={outsideClassName} label={label} disabled={loading} name={name} items={data}/> :
        <EnigooSelect onValueChange={onChange} outsideClassName={outsideClassName} label={label} name={name} disabled={loading} items={data}/>);

}
DeviceSelectField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isMulti: PropTypes.bool

}
